// extracted by mini-css-extract-plugin
module.exports = {"btnBlue":"main_btnBlue_ccQM3","btnBlueOutline":"main_btnBlueOutline_47-3M","invalidCoding":"main_invalidCoding_1448S"};